"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = __importDefault(require("node-fetch"));
class Wiki {
    constructor() {
        this.URL = 'https://oldschool.runescape.wiki/api.php';
        this.searchOptions = {
            '-incategory': ['Slang_dictionary', 'Disambiguation'].join('|')
        };
        this.commonPageAPIOptions = {
            action: 'query',
            format: 'json',
            prop: ['extracts', 'pageimages', 'info', 'categories'].join('|'),
            formatversion: '2',
            piprop: 'original',
            inprop: 'url',
            exsentences: '5',
            exintro: '1',
            explaintext: '1',
            cllimit: 'max'
        };
    }
    fetchPage(pageID) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield this.fetchAPI({
                iwurl: '1',
                pageids: pageID
            });
            if (!results || !results.query)
                return undefined;
            return this.parseRawPage(results.query.pages[0]);
        });
    }
    random(amount = 20) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield this.fetchAPI({
                generator: 'random',
                grnnamespace: '0',
                grnlimit: amount
            });
            if (!results || !results.query)
                return [];
            return results.query.pages.map(this.parseRawPage);
        });
    }
    search(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedSearchOptions = Object.keys(this.searchOptions)
                .map((prop) => `${prop}:${this.searchOptions[prop]}`)
                .join(' ');
            const results = yield this.fetchAPI({
                iwurl: '1',
                generator: 'search',
                gsrlimit: '20',
                gsrsearch: `${query} ${parsedSearchOptions}`
            });
            if (!results || !results.query || !results.query.pages)
                return [];
            return results.query.pages
                .sort((a, b) => a.index - b.index)
                .map(this.parseRawPage);
        });
    }
    parseRawPage(rawPage) {
        return {
            title: rawPage.title,
            extract: rawPage.extract,
            image: rawPage.original && rawPage.original.source,
            url: rawPage.fullurl,
            lastRevisionID: rawPage.lastrevid,
            pageID: rawPage.pageid,
            categories: rawPage.categories
        };
    }
    fetchAPI(query) {
        const apiURL = new URL(this.URL);
        apiURL.search = new URLSearchParams(Object.assign(Object.assign({}, this.commonPageAPIOptions), query)).toString();
        return node_fetch_1.default(apiURL.toString()).then((res) => res.json());
    }
}
exports.default = new Wiki();
//# sourceMappingURL=Wiki.js.map